function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.6 12.701L3.299 7.493 8.6 2.285A1.337 1.337 0 009 1.338a1.317 1.317 0 00-.4-.946A1.365 1.365 0 007.638 0a1.384 1.384 0 00-.963.392L.4 6.553a1.32 1.32 0 000 1.893l6.274 6.161a1.363 1.363 0 00.963.393 1.384 1.384 0 00.964-.393 1.348 1.348 0 000-1.906z",
  fill: "#50A684"
});

function SvgBack2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBack2;